import { Link } from "react-router-dom";

const SECTIONS = {
  terms: {
    title: "Terms of Service",
    updated: "February 2026",
    body: [
      ["1. Acceptance", "By using MeloCraft you agree to these terms. If you don't, don't use the service."],
      ["2. The Service", "MeloCraft is a marketplace where independent artists sell music, tips, bundles, and merch directly to fans. MeloCraft does not own the music sold on the platform — artists retain 100% of ownership."],
      ["3. Artist Accounts", "Artists must subscribe to the Artist Plan ($2/month) to sell music. Artists warrant that they own or have full rights to distribute any content they upload. Uploading content you don't own the rights to is fraud and will result in immediate account termination."],
      ["4. Payments", "MeloCraft charges $0 platform fee on song, album, tip, bundle, and merch sales — artists keep 100% (minus Stripe processing fees paid to Stripe, not MeloCraft). MeloCraft collects only the $2/month artist subscription and margins on platform-owned ad/social promotion packages."],
      ["5. Refunds", "Digital goods (songs, albums) are non-refundable once downloaded. Merch refunds follow the print partner's policy. Subscriptions can be canceled anytime and remain active through the end of the current billing period."],
      ["6. Prohibited Content", "No copyrighted material you don't own; no hate speech; no harassment; no illegal content. MeloCraft reserves the right to remove content and terminate accounts at its sole discretion."],
      ["7. Limitation of Liability", "MeloCraft is provided \"as is\" with no warranty. MeloCraft is not liable for any indirect, incidental, or consequential damages. Maximum liability is capped at the amount you paid MeloCraft in the prior 12 months."],
      ["8. Changes", "We may update these terms. Continued use after changes means you accept the new terms."],
      ["9. Contact", "Questions: Marcus_nelson_7@live.com"],
    ],
  },
  privacy: {
    title: "Privacy Policy",
    updated: "February 2026",
    body: [
      ["1. What We Collect", "Account info you give us (username, email, password hash, optional bio & banner), payment info handled by Stripe (we never see card numbers), play/purchase history for the analytics you see, and basic device info (browser, IP) for security."],
      ["2. How We Use It", "To run the service, process payments, deliver music, show you notifications, prevent fraud, and comply with law. We never sell your data."],
      ["3. Who We Share It With", "Stripe (payments), Resend (transactional email), Emergent (hosting), Printful (merch fulfillment when enabled). Nobody else."],
      ["4. Cookies", "We use a single auth token stored locally in your browser to keep you signed in. No third-party tracking cookies."],
      ["5. Your Rights", "You can update your profile, change your password, delete your account, and request an export of your data by emailing us."],
      ["6. Data Retention", "Account data is kept as long as your account is active. Purchase records are kept for 7 years (tax/legal). Deleted content is soft-deleted for 30 days then purged."],
      ["7. Children", "MeloCraft is not directed at children under 13. If we learn a child under 13 has registered, we'll delete the account."],
      ["8. Contact", "Privacy questions: Marcus_nelson_7@live.com"],
    ],
  },
  dmca: {
    title: "DMCA Copyright Policy",
    updated: "February 2026",
    body: [
      ["Notice of Infringement", "If you believe content on MeloCraft infringes your copyright, send us a DMCA takedown notice. We respond within 24-48 hours and will remove verified infringing content."],
      ["What to Include", "A physical or electronic signature; identification of the copyrighted work claimed to be infringed; the URL of the infringing content on MeloCraft; your contact information (name, address, phone, email); a statement that you have a good-faith belief the use is not authorized; a statement under penalty of perjury that the information is accurate and you are authorized to act."],
      ["Send To", "Marcus_nelson_7@live.com with subject line: \"DMCA Takedown — MeloCraft\""],
      ["Counter-Notice", "If your content was removed and you believe it was in error, you may send a counter-notice with the same required elements. MeloCraft follows the DMCA safe harbor process."],
      ["Repeat Infringers", "Accounts that receive multiple verified takedowns will be terminated."],
    ],
  },
  contact: {
    title: "Contact",
    updated: null,
    body: [
      ["Support", "For account issues, payment questions, artist verification, or anything else — email: Marcus_nelson_7@live.com"],
      ["Press & Partnerships", "Same email — subject line: \"Press\" or \"Partnership\""],
      ["Response time", "Usually within 24 hours."],
      ["Bug reports", "Include your browser, device, and a screenshot if possible."],
    ],
  },
};

export default function LegalPage({ which }) {
  const s = SECTIONS[which];
  if (!s) return <NotFound />;
  return (
    <div className="max-w-3xl mx-auto px-4 md:px-8 py-12 pb-32">
      <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#FF4500] mb-2">Legal</div>
      <h1 className="font-display font-black text-4xl md:text-6xl tracking-tighter">{s.title}</h1>
      {s.updated && <div className="font-mono text-xs text-gray-500 mt-2">Last updated · {s.updated}</div>}
      <div className="mt-10 space-y-8">
        {s.body.map(([h, p]) => (
          <div key={h}>
            <h2 className="font-display text-xl md:text-2xl mb-2">{h}</h2>
            <p className="font-mono text-sm text-gray-300 leading-relaxed">{p}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export function NotFound() {
  return (
    <div className="min-h-[calc(100vh-4rem)] grid place-items-center px-4">
      <div className="text-center">
        <div className="font-display font-black text-8xl md:text-9xl text-[#FF4500] tracking-tighter">404</div>
        <div className="font-mono text-xs uppercase tracking-[0.3em] text-gray-400 mt-4">This page never made the record</div>
        <Link to="/" data-testid="404-home-link" className="inline-block mt-8 px-6 py-3 bg-[#FF4500] hover:bg-[#E53E00] text-black font-mono text-xs uppercase tracking-widest transition-colors">
          Back to home
        </Link>
      </div>
    </div>
  );
}
